import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import axios from 'axios';

class FormUI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      naam: '',
      telefoonnummer: '',
      email: '',
      opmerkingen: '',
      error: false,
      success: false,
      message: ''
    };
  }

  componentDidMount() {

  }

  update(e) {
    let data = {};
    data[e.currentTarget.name] = e.currentTarget.value;
    this.setState(data);
  }

  onClose(e) {
    this.props.onClose();
    e.preventDefault;
  }

  send(e) {
    let _this = this;
    if (this.state.email.length <= 0) {
      this.setState({
        error: true,
        message: 'E-mail is verkeerd en verplicht'
      });
      return;
    }
    console.log(this.state.naam.length);
    if (this.state.naam.length <= 0) {
      this.setState({
        error: true,
        message: 'Naam is verplicht'
      });
      return;
    }

    this.setState({
      error: false
    });


    axios.post(`/dynamic/calls/contact/`, this.state)
    .then(()=> {
      this.setState({
        success: true,
        message: 'Uw bericht is verzonden'
      });
    })
    .catch((error)=> {
      this.setState({
        success: true,
        message: 'Sorry! Uw bericht is niet verzonden'
      });
    });

    e.preventDefault();
  }

  render() {

    const Message = ()=> this.state.error ? (
      <div className="form error_message">
        <p>{this.state.message}</p>
      </div>
    ) : null;

    if (this.state.success) {
      return (
        <div className="form_widget">
          <form>
            <div className="success_message">
              <p>{this.state.message}</p>
              <p>
                <a onClick={(e)=> this.onClose(e)} href="#">Sluiten</a>
              </p>
            </div>
          </form>
        </div>
      );
    }

    return(
      <div className="form_widget">
      <form>
        { Message() }
        <div className="row">
          <label>
            <input onBlur={(e)=> this.update(e)} required={true} type="text"
              name="naam"
              placeholder={'Naam'}
              defaultValue={this.state.naam} 
               />
          </label>
        </div>
        <div className="row">
          <label>
            <input onBlur={(e)=> this.update(e)} required={true} type="text"
              name="telefoonnummer"
              placeholder={'Telefoonnummer'}
              defaultValue={this.state.telefoonnummer} 
               />
          </label>
        </div>
        <div className="row">
          <label>
            <input onBlur={(e)=> this.update(e)} required={true} type="text"
              name="email"
              placeholder={'E-mail'}
              defaultValue={this.state.email} 
               />
          </label>
        </div>
        
        <div className="row">
          <label>
            <textarea name="opmerkingen" onBlur={(e)=> this.update(e)} placeholder={'Speciale wensen, vragen of opmerkingen?'} />

          </label>
        </div>
        <div onClick={(e)=> this.send(e)} className="btns">
          <a href="#" className="btn">
            Versturen
          </a>
        </div>
      </form>
        <a href="#" onClick={(e)=> this.onClose(e)} className="close_btn i-close i-cross">&#10006;</a>
      </div>
    );
  }
}


export default class Form  {
  constructor() {
    this.panel = document.querySelector('body');
    if (window.location.hash === '#contact') {
      this.render();
    }
    if (window.location.pathname.indexOf('contact') > -1) {
      this.renderStatic();   
    }
    this.controller();  
  }


  renderStatic() {
    let el = document.getElementById('contact_form');
    if (el) {
      ReactDOM.render(<FormUI onClose={()=> this.onClose()} />, el);
    }
  }

  render() {
    this.view();

    
    ReactDOM.render(<FormUI onClose={()=> this.onClose()} />, this.form);

    
  }

  controller() {
    window.addEventListener('hashchange',  ()=> window.location.hash === '#contact' ? this.render() : null);
    //
  }

  onClose() {
    this.panel.removeChild(this.form);
  }

  view() {
    this.form = document.createElement('div');
    this.form.className = classNames('register_form_ui');
    this.panel.appendChild(this.form);
  }
}


// WEBPACK FOOTER //
// ./modules/Form.js